module.exports = __webpack_public_path__ + "img/11.d0289dc0.png";